import type {RagThreadDTO} from 'crqlar-react-common/dist/models/ai/ragThread.model';

/** A thread is "pending" while it's waiting on a human reply. */
export const hasPendingHandoff = (thread: RagThreadDTO): boolean =>
    thread.handoffStatus === 'WAITING';

/** Team replies stay unread until the user-facing read cursor reaches the latest message. */
export const hasUnreadTeamReply = (thread: RagThreadDTO): boolean =>
    thread.lastMessageAuthor === 'AGENT'
    && thread.lastMessageSeq !== undefined
    && thread.lastMessageSeq > (thread.userLastReadSeq ?? -1);

/**
 * Thread message sequences are local to each thread, so recency must come from the message time.
 * The list endpoint already returns a useful order; preserve it when timestamps are absent or tied.
 */
export const getUnreadTeamThreadIds = (threads: readonly RagThreadDTO[]): string[] =>
    threads
        .map((thread, index) => ({thread, index}))
        .filter(({thread}) => !!thread.id && hasUnreadTeamReply(thread))
        .sort((a, b) => {
            const aTime = messageTime(a.thread.lastMessageAt);
            const bTime = messageTime(b.thread.lastMessageAt);
            return bTime - aTime || a.index - b.index;
        })
        .map(({thread}) => thread.id!);

const messageTime = (value?: Date): number => {
    if (!value) return 0;
    const time = new Date(value).getTime();
    return Number.isFinite(time) ? time : 0;
};
